// extracted by mini-css-extract-plugin
export var gatsbyFocusWrapper = "Footer-module--gatsby-focus-wrapper--AQKo0";
export var ___gatsby = "Footer-module--___gatsby--1PYj4";
export var footerWrapper = "Footer-module--footer-wrapper--28Da5";
export var title = "Footer-module--title--1TUHK";
export var vertical = "Footer-module--vertical--127vI";
export var logo = "Footer-module--logo--3Y3gK";
export var misc = "Footer-module--misc--1gRnQ";
export var app = "Footer-module--app--2udu3";
export var badge = "Footer-module--badge--3mNkD";
export var sns = "Footer-module--sns--3fhvj";